import { render } from "./Words.vue?vue&type=template&id=6c9b24cc"
import script from "./Words.vue?vue&type=script&lang=js"
export * from "./Words.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__